<div class="login">

  <!-- Right panel: form -->
  <div class="login__panel login__panel--right">

    <form *ngIf="!submitted" class="login-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <div class="login-form__field">
        <h2 class="login-form__label">Forgot your password?</h2>
        <p class="login-form__hint">Enter your email and we'll send you a link to reset it.</p>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="email">Email</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="email"
            id="email"
            formControlName="email"
            placeholder="name@mila.com"
            autocomplete="email"
          />
        </div>
      </div>

      <div class="login-form__actions">
        <button class="btn btn--primary" type="submit" [disabled]="isLoading">Send reset link</button>
        <p class="login-form__footer">
          Remembered it? <a routerLink="/login" class="link">Back to sign in</a>
        </p>
      </div>

    </form>

    <div *ngIf="submitted" class="login-form">
      <div class="login-form__field">
        <h2 class="login-form__label">Check your email</h2>
        <p class="login-form__hint">
          If <strong>{{ submittedEmail }}</strong> belongs to an account, a password reset link is on its way.
        </p>
      </div>

      <div class="login-form__actions">
        <a routerLink="/login" class="btn btn--primary">Back to sign in</a>
      </div>
    </div>

  </div>

  <!-- Left panel: branding mosaic -->
  <div class="login__panel login__panel--left">
    <app-auth-panel></app-auth-panel>
  </div>

</div>
